export enum ModalSize {
    Sm = 'sm',
    Lg = 'lg',
    Xl = 'xl',
}

// For backwards compatibility as previously union type was used for modal size
export type ModalSizeType = `${ModalSize}`;
